import * as React from "react"
import ProjectCard from "./projectCard"
import Spacer from "../components/spacer"
const MoreProjects = ({ projects }) => {
  return (
    <div className='more--projects p10'>
      <Spacer />
      <h1 className="m0 p10 text-center sm text-light">More</h1>
      <Spacer />
      <div className='project--grid grid'>

        {projects.slice(0, 3).map((project, index) => {
          return (
            <ProjectCard project={project.node} key={index} />
          )
        })}
      </div>
    </div>
  )
}
export default MoreProjects
